import "./Solutions.module.css";
import Header from "@/reusable_sections/Header";
import HowItWorks from "./sections/HowItWorks";
import TheNeighborlyAdvantage from "./sections/TheNeighborlyAdvantage";
import JoinUsAtTheTable from "./sections/JoinUsAtTheTable";
import Footer from "@/reusable_sections/Footer";
export default function SolutionsPage() {
  return <div>
      <Header />
      <HowItWorks />
      <TheNeighborlyAdvantage />
      <JoinUsAtTheTable />
      <Footer />
    </div>;
}